import { FormGroup, FormControl } from '@angular/forms';

// ZIPCODE VALIDATOR
// export function zipcodeValidator(control: FormControl):{[key: string]: any} {
//   let re = /^[0-9]{5}$/;

//   if (typeof(control.value) !== "string") return;

//   if(control.value && !re.test(control.value.trim())) {
//     return { invalidZipcode: true };
//   }
// }

// PHONE NUMBER VALIDATOR
export function phoneNumberValidator(
  control: FormControl
): { [key: string]: any } {
  const re = /0[0-9]{1,2}-(?=[^01])[0-9]{3,4}-[0-9]{4}/;

  if (typeof control.value !== 'string') {
    return;
  }

  if (control.value && !re.test(control.value.trim())) {
    return { invalidPhoneNumber: true };
  }
}

// POSITIVE NUMBER VALIDATOR
export function positiveIntValidator(
  control: FormControl
): { [key: string]: any } {
  const re = /^[0-9]+$/;
  // let number = control.value.trim();
  // console.log("KKK", control.value)

  if (typeof control.value !== 'string') {
    return;
  }

  if (
    control.value &&
    (!re.test(control.value.trim()) || Number(control.value) <= 0)
  ) {
    return { invalidNumber: true };
  }
}

// TICKET VALIDATORS
export function ticketValidator(control: FormControl): { [key: string]: any } {
  const ticketRegexp = /\b\d{4}[-.]?\d{4}[-.]?\d{4}[-.]?\d{4}\b/;
  if (control.value && !ticketRegexp.test(control.value)) {
    return { invalidTicket: true };
  }
}

// EMAIL VALIDATORS
export function emailValidator(control: FormControl): { [key: string]: any } {
  // var emailRegexp = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  const emailRegexp = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
}

// MULTIPLE EMAILS VALIDATOR
export function multiEmailValidator(
  control: FormControl
): { [key: string]: any } {
  if (!control.value) {
    return;
  }
  let hasError = false;
  const emails = control.value.split(/[;,\s]+/);
  const emailRegexp = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  for (let email of emails) {
    if (email && !emailRegexp.test(email)) {
      hasError = true;
      break;
    }
  }

  if (control.value && hasError) {
    return { invalidEmail: true };
  }
}

// PRICING FORM VALIDATOR

export function priceValidator(
  priceKey: string,
  discountedKey: string,
  publishedKey: string,
  periodKey?: string
) {
  return (group: FormGroup) => {
    const priceInput = group.controls[priceKey];
    const discountedInput = group.controls[discountedKey];
    const publishedInput = group.controls[publishedKey];
    const periodInput = periodKey ? group.controls[periodKey] : undefined;

    const priceErrors = priceInput.errors || {};
    const discountedErrors = discountedInput.errors || {};
    const periodErrors = periodInput ? periodInput.errors || {} : undefined;

    // console.log(priceInput.value, discountedInput.value, publishedInput.value)

    // set error when published is set, but price is not set
    // set error when price is negative
    if (
      (publishedInput.value && priceInput.value === null) ||
      priceInput.value < 0
    ) {
      priceErrors['noPrice'] = true;
    } else {
      delete priceErrors['noPrice'];
    }

    // set error when published is set, but discountedprice is not set
    // set error when discounted price > price, or discounted price < 0
    if (
      (publishedInput.value && discountedInput.value === null) ||
      priceInput.value < discountedInput.value ||
      discountedInput.value < 0
    ) {
      discountedErrors['wrongDiscount'] = true;
    } else {
      delete discountedErrors['wrongDiscount'];
    }

    if (periodInput) {
      if (publishedInput.value && periodInput.value === null) {
        periodErrors['noPeriod'] = true;
      } else {
        delete periodErrors['noPeriod'];
      }
    }

    if (
      Object.keys(priceErrors).length === 0 &&
      priceErrors.constructor === Object
    ) {
      priceInput.setErrors(null);
    } else {
      priceInput.setErrors(priceErrors);
    }

    if (
      Object.keys(discountedErrors).length === 0 &&
      discountedErrors.constructor === Object
    ) {
      discountedInput.setErrors(null);
    } else {
      discountedInput.setErrors(discountedErrors);
    }

    if (periodInput) {
      if (
        Object.keys(periodErrors).length === 0 &&
        periodErrors.constructor === Object
      ) {
        periodInput.setErrors(null);
      } else {
        periodInput.setErrors(periodErrors);
      }
    }

    return {};
  };
}

// 대여 on -> error, 0원 -> error
export function premiumPriceFeatureValidator(
  priceKey: string,
  discountedKey: string,
  publishedKey: string,
  periodKey?: string
) {
  return (group: FormGroup) => {
    const priceInput = group.controls[priceKey];
    const discountedInput = group.controls[discountedKey];
    const publishedInput = group.controls[publishedKey];
    const periodInput = periodKey ? group.controls[periodKey] : undefined;

    const priceErrors = priceInput.errors || {};
    const discountedErrors = discountedInput.errors || {};
    const periodErrors = periodInput ? periodInput.errors || {} : undefined;

    const groupErrors = {};

    if (discountedInput.value !== null && discountedInput.value === 0) {
      discountedErrors['premiumFeature'] = true;
      groupErrors['premiumFeature'] = true;
    } else {
      delete discountedErrors['permiumFeature'];
      delete groupErrors['permiumFeature'];
    }

    if (periodInput) {
      if (publishedInput.value) {
        groupErrors['premiumFeature'] = true;
      } else {
        delete groupErrors['premiumFeature'];
      }
    }

    if (
      Object.keys(discountedErrors).length === 0 &&
      discountedErrors.constructor === Object
    ) {
      discountedInput.setErrors(null);
    } else {
      discountedInput.setErrors(discountedErrors);
    }

    return groupErrors;
  };
}

// SIMPLE PRICING FORM VALIDATOR

export function simplePriceValidator(priceKey: string, discountedKey: string) {
  return (group: FormGroup) => {
    const priceInput = group.controls[priceKey];
    const discountedInput = group.controls[discountedKey];

    let priceErrors = priceInput.errors;
    let discountedErrors = discountedInput.errors;
    if (!priceErrors) {
      priceErrors = {};
    }
    if (!discountedErrors) {
      discountedErrors = {};
    }

    if (typeof priceInput.value !== 'number') {
      priceErrors['wrongPrice'] = true;
    }

    // set error when price is negative or price is not set
    if (priceInput.value === null || priceInput.value < 0) {
      priceErrors['noPrice'] = true;
    } else {
      delete priceErrors['noPrice'];
    }

    // set error when discounted price > price, or discounted price < 0
    // set error when discounted price is not set
    if (
      discountedInput.value === null ||
      priceInput.value < discountedInput.value ||
      discountedInput.value < 0
    ) {
      discountedErrors['wrongDiscount'] = true;
    } else {
      delete discountedErrors['wrongDiscount'];
    }

    if (
      Object.keys(priceErrors).length === 0 &&
      priceErrors.constructor === Object
    ) {
      priceInput.setErrors(null);
    } else {
      priceInput.setErrors(priceErrors);
    }

    if (
      Object.keys(discountedErrors).length === 0 &&
      discountedErrors.constructor === Object
    ) {
      discountedInput.setErrors(null);
    } else {
      discountedInput.setErrors(priceErrors);
    }

    return;
  };
}

// PASSWORD GROUP VALIDATORS
export function matchingPasswords(
  passwordKey: string,
  passwordConfirmationKey: string
) {
  return (group: FormGroup) => {
    const passwordInput = group.controls[passwordKey];
    const passwordConfirmationInput = group.controls[passwordConfirmationKey];

    let errors = passwordConfirmationInput.errors;
    if (!errors) {
      errors = {};
    }

    if (passwordInput.value !== passwordConfirmationInput.value) {
      errors['notEqual'] = true;
    } else {
      delete errors['notEqual'];
    }

    // console.log(errors);
    if (Object.keys(errors).length === 0 && errors.constructor === Object) {
      // console.log("no error")
      return passwordConfirmationInput.setErrors(null);
    } else {
      return passwordConfirmationInput.setErrors(errors);
    }
  };
}
